import { Reference, Property, Name, Output } from '@components/Reference';
import Cell from '@components/Cell';
import Sandbox from '@components/Sandbox';
import * as React from 'react';
export default {
  Reference,
  Property,
  Name,
  Output,
  Cell,
  Sandbox,
  React
};